import api from '@/api';

import { API_BASE_URL } from '..';
import {
  CountKit,
  CreateKitRequest,
  CreateKitResponse,
  EditKitRequest,
  Kit,
  KitReduced,
  KitsQueryFilters,
} from './Kits.types';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API_BASE_URL}/kit`;

export async function listKitsReduced(params?: KitsQueryFilters) {
  const result = (await api.get(
    `${CONTROLLER_URL}/reduced`,
    params,
  )) as unknown;

  return result as PageResult<KitReduced>;
}

export async function detailKit(kitId?: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${kitId}`, null)) as unknown;

  return result as Kit;
}

export async function createKit(
  obj: CreateKitRequest,
): Promise<CreateKitResponse> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as CreateKitResponse;
}

export async function editKit(obj: EditKitRequest): Promise<EditKitRequest> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as EditKitRequest;
}

export async function deleteKit(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result as void;
}

export async function countKit() {
  const result = (await api.get(`${CONTROLLER_URL}/count`, null)) as unknown;

  return result as CountKit;
}
